import React from "react";
import './SimpleButton.css';

const Button = ({
  text="simple button",
  classes = "",
  type="text",
  disabled = false,
  ...props
}) => {
  var _class = classes+" pure-button button-large simples-button";
    return (
        <button
          type={type}
          className={_class}
          disabled={disabled}>
         {text}</button>
    );
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/buttons/Button.js